
'use client';

import React from 'react';
import { StyledDiv } from './featurePageBento.styles';
import { IFeaturePage } from '@/types';
import Image from 'next/image';
import { useInView } from 'react-intersection-observer';

interface IFeaturePageHeroProps {
    page: IFeaturePage;
}

export const FeaturePageBento = ({ page }: IFeaturePageHeroProps) => {
    const { ref, inView } = useInView({
        threshold: 0.2,
        triggerOnce: true,
    });

    return (
        <StyledDiv>
            {page.bento.title &&
                <h3>{page.bento.title}</h3>
            }
            <p className='description'>{page.bento.description}</p>

            <div
                ref={ref}
                className={`bento-container ${inView ? 'in-view' : ''}`}
            >
                {page.bento.items.map((item, idx) => (
                    <div
                        key={idx}
                        className={`bento-item item-${idx + 1}`}
                        style={{ animationDelay: `${idx * 0.2}s` }}
                    >
                        <div className="bento-image-container">
                            <Image
                                fill
                                src={item.image}
                                alt={item.title}
                                className="bento-image"
                            />
                        </div>
                        <div className="bento-content">
                            <h4>{item.title}</h4>
                            <p>{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </StyledDiv>
    );
};
